<template>
  <div id="container" class="member_st">
    <!-- 개인정보수정 & sub menu -->
    <AccountHead />

    <!-- 쿠폰 관리 START -->
    <div class="section fill">
      <div class="inner">
        <div class="box_title">
          <h2 class="mb-2">선물 번호 입력</h2>
          <div class="input_wrap">
            <label for="cp" class="lb_wrap">
              <!-- <span class="ab_text">{{ couponCd }}</span> -->
              <input
                id="cp"
                v-model="couponNo"
                type="text"
                placeholder="선물 번호를 입력하세요"
                @input="inputValid($event)"
              />
            </label>
          </div>
          <div>
            <a
              class="box_btn"
              :class="isValid ? '' : 'disabled'"
              @click="requestGift"
            >
              <span class="an_t">확인</span>
              <!-- <span class="an_t">확인</span> -->
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- ERROR MODAL START -->
    <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="toggleErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_inner">
              <strong>
                {{ errorMessage }}
              </strong>
              <p>
                {{ subErrMsg }}
              </p>
              <div class="btnWrap">
                <button class="box_btn" @click="toggleErrorModal">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
    <!-- ERROR MODAL END -->
  </div>
</template>

<script>
import AccountHead from '../../components/member/AccountHead.vue'

export default {
  name: 'Gift',
  components: { AccountHead },
  data() {
    return {
      showErrorModal: false,
      errorMessage: false,
      subErrMsg: '',
      couponNo: '',
      setData: '',
      isValid2: true
    }
  },
  computed: {
    isValid() {
      return this.isValid2
    }
  },
  methods: {
    inputValid(e) {
      console.log(e)
      // const y = e.target.value.replaceAll('-', '')
      // let en_Reg = /^(?=.*[a-zA-Z])/gi
      // let ko_Reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g
      // let validSpace = /\s/g
      // let spcReg = /^(?=.[~!@#$%^&()_+[=\]|.,'";<>?:{}])/gi
      // this.isValid2 = false
      // if (
      //   en_Reg.test(y) ||
      //   validSpace.test(y) ||
      //   spcReg.test(y) ||
      //   ko_Reg.test(y)
      // ) {
      //   this.couponNo = y
      //     .toString()
      //     .replace(/\B(?=(\d{4})+(?!\d))/g, '-')
      //     .slice(0, -1)
      //   console.log('숫자만 입력하세요.')
      //   return
      // }
      // if (y.length >= 17) {
      //   this.isValid2 = true
      //   this.couponNo = y.slice(0, -1).replace(/\B(?=(\d{4})+(?!\d))/g, '-')
      //   return
      // }
      // if (e.inputType == 'deleteContentBackward') {
      //   this.isValid2 = false
      //   return
      // }
      // if (y.length !== 0 && y.length % 4 === 0) {
      //   if (y.length === 16) {
      //     this.isValid2 = true
      //   }
      //   this.couponNo = y.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '-')
      // }
    },
    async requestGift() {
      if (!this.isValid) {
        return
      }
      await this.$store
        .dispatch('requestGifte', {
          purchaseTp: 'GFT',
          couponNo: this.couponNo
        })
        .then((res) => {
          if (res.data.ok) {
            this.errorMessage = '쿠폰 적용이 완료되었습니다.'
            this.subErrMsg = "내 서재'에서 등록된 도서를 확인해주세요."
            this.toggleErrorModal()
          }
        })
        .catch((err) => {
          console.log(err.response.data.errorState.reason)
          if (err.response) {
            this.errorMessage = err.response.data.errorState.reason
            this.subErrMsg = '쿠폰 번호 확인 후 다시 입력해주세요.'
            this.toggleErrorModal()
          }
        })
    },
    // hint

    toggleErrorModal() {
      // e.preventDefault()
      this.showErrorModal = !this.showErrorModal
    }
  }
}
</script>

<style lang="scss" scoped>
.input_wrap {
  display: flex;
  justify-content: center;
}
.lb_wrap {
  position: relative;
  width: 460px;
  height: 48px;
  input {
    // color: transparent;
    position: absolute;
    z-index: 99;
    left: 0;
    top: 0;
    margin: 0;
    background: transparent;
    padding-left: 16px;
  }
  .ab_text {
    z-index: 98;
    padding-left: 16px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    color: black;
    position: absolute;
    left: 0;
    top: 0;
  }
}
.ly_pop_content.ly_pop_msg.ly_txt {
  width: 540px;
  height: 257px;
  text-align: center;
  .ly_inner {
    padding-top: 60px !important;
    p {
      font-size: 16px;
      color: #778899;
    }
  }
}
input {
  width: 460px;
  height: 48px;
  margin-top: 40px;
  border: 1px solid #d5dff3;
  box-sizing: border-box;
  border-radius: 12px;
}

.box_title {
  .box_btn {
    width: 460px;
    height: 48px !important;
    margin-top: 16px;
    border-radius: 3px;
  }
}

.btnWrap {
  margin-top: 30px;
  text-align: center;
  .box_btn {
    width: 76px;
    height: 40px;
    .an_t {
      line-height: 40px !important;
    }
  }
}
.box_title .box_btn .an_t {
  line-height: 48px;
}
.disabled {
  background-color: #778899;
  border-color: #778899;
}
.member_st .box_title {
  display: block !important;
}
@media screen and (max-width: 520px) {
  input {
    width: 100%;
  }

  .box_title {
    .box_btn {
      width: 100%;
    }
  }
}
</style>
